
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.688 2.313h3.937a.75.75 0 01.75.75v15.562a.75.75 0 01-.75.75H1.375a.75.75 0 01-.75-.75V3.062a.75.75 0 01.75-.75h3.938v-1.5c0-.103.084-.187.187-.187h1.313c.103 0 .187.084.187.188v1.5h6v-1.5c0-.104.084-.188.188-.188H14.5c.103 0 .188.084.188.188v1.5zM2.312 8.78v8.906h15.376V8.781H2.313zm0-4.781v3.188h15.376V4h-3v1.125a.188.188 0 01-.188.188h-1.313A.188.188 0 0113 5.125V4H7v1.125a.188.188 0 01-.188.188H5.5a.188.188 0 01-.188-.188V4h-3zM6.5 13a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0zm3.366 1.138l1.646-2.281c.03-.041 0-.1-.051-.1h-.367a.25.25 0 00-.202.105l-1.228 1.703-.556-.772a.249.249 0 00-.203-.104H8.54c-.05 0-.08.058-.05.1l.973 1.35a.249.249 0 00.404 0z"}})])
          )
        }
      }
    